import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { ImageCropperPopupComponent } from 'src/app/popups/image-cropper-popup/image-cropper-popup.component';
import { CommonService } from 'src/app/services/common.service';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { LoginModel } from '../../models/legacy';
import { UserProfileModel } from '../../models/repository/user-profile.model';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { EventsEmitter } from '../../shared/event-emitter/EventEmitter';
import { CountryISO, PhoneNumberFormat, SearchCountryField, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { FormUtilsService } from 'src/app/services/formUtils.service';


@Component({
  selector: 'sales-company-profile',
  templateUrl: './sales-company-profile.component.html',
  styleUrls: ['./sales-company-profile.component.scss'],
})
export class SalesCompanyProfileComponent
  extends BaseUnsubscribeComponent
  implements OnInit {
  @Input() public userType: string;
  @Input() public isUseBuiltInSave = true;
  @Input() public formLoader = false;
  public userProfileForm: FormGroup;
  public isLoader = false;
  public closeResult = '';
  public SearchCountryField = SearchCountryField;
  public CountryISO = CountryISO;
  public PhoneNumberFormat = PhoneNumberFormat;
  public preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.Australia, CountryISO.NewZealand, CountryISO.SouthAfrica, CountryISO.France];

  public responseSuccess: any = null;
  public responseError: any = null;

  public submitted = false;

  private file: File;
  private headerFile: File;
  public userProfleModel: UserProfileModel;
  @ViewChild('fileInput') el: ElementRef;
  @ViewChild('headerFileInput') elHeader: ElementRef;
  public logoImage: any = 'assets/images/no-image-placeholder.jpeg';
  public headerImage: any = 'assets/images/no-image.png';
  public user: LoginModel;
  countries: any[] = [];
  public constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly eventEmitter: EventsEmitter,
    private readonly location: Location,
    private toastService: ToastService,
    private readonly modalService: NgbModal,
    private commonService: CommonService,
    private formUtilsService: FormUtilsService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.isLoader = true;
    this.loadUser();
    this.loadProfile();
    this.userProfileForm = this.formBuilder.group({
      organisation: ['', [Validators.required]],
      displayName: ['', [Validators.required]],
      headerImage: [''],
      logoImage: [''],
      locationText: [''],
      homeText: [''],
      aboutText: [''],
      aboutVideoEmbedUrl: [''],
      homeVideoEmbedUrl: [''],
      websiteUrl: [''],
      facebookUrl: [''],
      twitterHandle: [''],
      instagramHandle: [''],
      enquiryEmailAddress: ['', [Validators.email]],
      isShowOnWebsite: [false],
      address: [''],
      addressLine2: [''],
      stateName: [''],
      replyToEmailAddress: [''],
      postCode: [''],
      countryName: [''],

      phoneNumber: [''],
      phoneNumberCountryCode: [''],
      phoneNumberControl: {
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      },
      faxNumberControl: {
        number: '',
        internationalNumber: '',
        nationalNumber: '',
        countryCode: 'us',
        dialCode: '+1'
      },

      selectedPNCountryISO: null,
      selectedFNCountryISO: null,

      smsNumber: [''],
      faxNumber: [''],
      faxNumberCountryCode: [''],
      suburb: [''],
    });

    this.commonService.getCountries().subscribe((response) => {
      if (response.body) {
        const responseData = JSON.parse(JSON.stringify(response.body));
        if (responseData) {
          this.countries = responseData;

          if (this.countries && this.countries?.length > 0) {
          }
        }
      }
    });
  }

  public formSubmit(): void {

    if (this.userProfileForm.invalid) {
      return;
    }
    this.submitted = true;
    let formData = new FormData();
    const form = this.userProfileForm.value;

    //form.smsNumber = form.smsNumberControl?.internationalNumber;
    
    form.phoneNumber = form.phoneNumberControl?.internationalNumber.replace(form.phoneNumberControl?.dialCode || '', '') || '';
    form.phoneNumberCountryCode = form.phoneNumberControl?.dialCode || '';
    form.faxNumber = form.faxNumberControl?.internationalNumber.replace(form.faxNumberControl?.dialCode || '', '') || '' ;
    form.faxNumberCountryCode = form.faxNumberControl?.dialCode || '';
    
   
   //form.phoneNumber = form.phoneNumberControl?.number || '';
   //form.faxNumber = form.faxNumberControl?.number || '' ;

    for (var key in form) {
      formData.append(key, form[key] === null ? '' : form[key]);
    }

    if (this.file) {
      formData.append('logoFile', this.file);
    }
    if (this.headerFile) {
      formData.append('headerFile', this.headerFile);
    }
    this.userService
      .postMemberProfile(formData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          this.eventEmitter.emitTopBannerEvent(response);
          if (response) {
            this.toastService.success('Profile has been updated');
            this.location.back();
          }
        },
        (errorResponse: Error) => {
          this.submitted = false;
          const errorData = JSON.parse(JSON.stringify(errorResponse));
          if (errorData?.error) {
            if (errorData?.status === 401 || errorData?.status === 500) {
              this.toastService.error(errorData.error.message);
            }

            if (errorData?.status === 400) {
              let errorMessages = '';
              if (errorData.error instanceof Array) {
                errorData.error.forEach((value: { message: string }) => {
                  errorMessages += value.message + '\n';
                });
              } else {
                errorMessages = errorData.error.message;
              }
              this.toastService.error(errorMessages);
            }
          }
        }
      );
  }
  private setDefaultCountryFromDialCode(code: string): string {
    var countryCode = '';
    if (code) {
      const dialCode = code.replace('+', '');
      const matched = (window as any).intlTelInputGlobals.getCountryData().find((c: any) => c.dialCode === dialCode);

      if (matched) {
        countryCode = matched.iso2.toUpperCase() as CountryISO;
      }
    }
    return countryCode;
  }
  // Simple country code detection - expand as needed
  /*private getCountryCodeFromPhone(phoneNumber: string): string {
    const matchedCountry = typeof phoneNumber === 'undefined' || phoneNumber === '' ? '' : this.countries.find(country =>
      phoneNumber.startsWith(country.code));

    return matchedCountry?.code ?? ''; // Default
  }*/
  private isNullOrUndefined(value: any): value is null | undefined | '' {
    return (value === '' || value === undefined) ? null : value;
  }

  isFormValid(): boolean {
    this.submitted = true;
    this.formUtilsService.MarkFormFieldsTouched(this.userProfileForm);
    return !this.userProfileForm.invalid;
  }

  getFormData() {
    this.submitted = true;

    if (this.userProfileForm.invalid) {
      return null;
    }

    let formData = new FormData();
    const form = this.userProfileForm.value;

    form.phoneNumber = this.isNullOrUndefined(form.phoneNumberControl?.internationalNumber) != null ? form.phoneNumberControl?.internationalNumber.replace(form.phoneNumberControl?.dialCode || '','') : null;
    form.faxNumber = this.isNullOrUndefined(form.faxNumberControl?.internationalNumber) != null ? form.faxNumberControl?.internationalNumber.replace(form.faxNumberControl?.dialCode || '','') : null ;
    form.phoneNumberCountryCode = form.phoneNumberControl?.dialCode || '';
    form.faxNumberCountryCode = form.faxNumberControl?.dialCode || '';


    for (var key in form) {
      formData.append(key, form[key] === null ? '' : form[key]);
    }
    if (this.file) {
      formData.append('logoFile', this.file);
    }
    if (this.headerFile) {
      formData.append('headerFile', this.headerFile);
    }
    return formData;
  }


  uploadFile(event: Event) {
    const modalRef = this.modalService.open(ImageCropperPopupComponent, {
      ariaLabelledBy: 'LogoImageCropperId',
      centered: true,
      size: 'md',
      keyboard: false,
      backdrop: 'static',
    });

    const data = {
      file: event,
      from: 'imageFile',
      aspectRatio: 4 / 4,
      cropperMinWidth: 500,
      cropperMinHeight: 500,
      cropperMaxWidth: 500,
      cropperMaxHeight: 500,
      roundCropper: false,
      containWithinAspectRatio: false,
      maintainAspectRatio: true,
      format: 'png',
      alignImage: 'left',
    };

    modalRef.componentInstance.data = data;
    modalRef.result.then(
      (result) => {
        const data = result;
        this.logoImage = data.croppedImageBase64;
        this.file = data.croppedImageFile;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  uploadHeaderFile(event: Event) {
    const modalRef = this.modalService.open(ImageCropperPopupComponent, {
      ariaLabelledBy: 'HeaderImageCropperId',
      centered: true,
      size: 'md',
      keyboard: false,
      backdrop: 'static',
    });

    const data = {
      file: event,
      from: 'imageFile',
      aspectRatio: 3 / 1,
      cropperMinWidth: 620,
      cropperMinHeight: 250,
      cropperMaxWidth: 620,
      cropperMaxHeight: 250,
      roundCropper: false,
      containWithinAspectRatio: false,
      maintainAspectRatio: true,
      format: 'png',
      alignImage: 'left',
    };

    modalRef.componentInstance.data = data;
    modalRef.result.then(
      (result) => {
        const data = result;
        this.headerImage = data.croppedImageBase64;
        this.headerFile = data.croppedImageFile;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  public loadUser(): void {
    this.authService.getUserData().subscribe((data) => {
      if (data) {
        this.user = JSON.parse(data);
      }
    });
  }
  public loadProfile(): void {
    if (this.user) {
      this.userService
        .getMemberProfile()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (response) => {
            if (response) {
              this.userProfleModel = response;
              if (this.userProfleModel.logoImage) {
                this.logoImage = this.userProfleModel.logoImage;
              }
              if (this.userProfleModel.headerImage) {
                this.headerImage = this.userProfleModel.headerImage;
              }
              const formData = {
                organisation: this.userProfleModel?.organisation,
                displayName: this.userProfleModel?.displayName,
                locationText: this.userProfleModel?.locationText,
                homeText: this.userProfleModel?.homeText,
                aboutText: this.userProfleModel?.aboutText,
                aboutVideoEmbedUrl: this.userProfleModel?.aboutVideoEmbedUrl,
                homeVideoEmbedUrl: this.userProfleModel?.homeVideoEmbedUrl,
                logoImage: this.userProfleModel?.logoImage,
                headerImage: this.userProfleModel?.headerImage,
                websiteUrl: this.userProfleModel?.websiteUrl,
                facebookUrl: this.userProfleModel?.facebookUrl,
                twitterHandle: this.userProfleModel?.twitterHandle,
                instagramHandle: this.userProfleModel?.instagramHandle,
                enquiryEmailAddress: this.userProfleModel?.enquiryEmailAddress,
                address: this.userProfleModel?.address,
                addressLine2: this.userProfleModel?.addressLine2,
                stateName: this.userProfleModel?.stateName,
                countryName: this.userProfleModel?.countryName,
                postCode: this.userProfleModel?.postCode,
                phoneNumber: this.userProfleModel?.phoneNumber,
                selectedPNCountryISO: this.userProfleModel?.phoneNumber != null ? this.setDefaultCountryFromDialCode(this.userProfleModel?.phoneNumberCountryCode).trim() : null,
                phoneNumberControl: this.userProfleModel?.phoneNumber != null ? this.userProfleModel?.phoneNumber.replace(this.userProfleModel?.phoneNumberCountryCode, '').trim() : null,
                phoneNumberCountryCode: this.userProfleModel?.phoneNumberCountryCode,
                smsNumber: this.userProfleModel?.smsNumber,
                replyToEmailAddress: this.userProfleModel.replyToEmailAddress,
                suburb: this.userProfleModel?.suburb,
                faxNumber: this.userProfleModel?.faxNumber,
                selectedFNCountryISO: this.userProfleModel?.faxNumber != null ? this.setDefaultCountryFromDialCode(this.userProfleModel?.faxNumberCountryCode).trim() : null,
                faxNumberControl: this.userProfleModel?.faxNumber != null ? this.userProfleModel?.faxNumber.replace(this.userProfleModel?.faxNumberCountryCode, '').trim() : null,
                contactNumber2: this.userProfleModel?.contactNumber2,
                isShowOnWebsite:
                  this.userProfleModel?.isShowOnWebsite == 'False'
                    ? false
                    : true,
                file: '',
                headerFile: '',
              };

              this.userProfileForm.patchValue(formData);
            }

            this.isLoader = false;
          },
          (error) => {
            if (error.status === 401) {
              this.authService.logout();
              window.location.href = '/';
            }
          }
        );
    }
  }
}
